import Vue from 'vue'
import Authenticater from './authenticater'

Vue.use(Authenticater)

export default new Authenticater()